// extracted by mini-css-extract-plugin
module.exports = {"root":"Tag_root__33i5g","isInteractive":"Tag_isInteractive__1Df8D"};